"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.StyledFinalTotal=void 0;const StyledFinalTotal=exports.StyledFinalTotal=_styledComponents.default.div`
  display: flex;
  justify-content: space-between;
  background-color: black;
  padding: 16px 20px;

  .finalTotalFont {
    color: white;
  }
`;